(function () {
  var bannerSwiper;
  var $slider;
  var slideCount;

  $(function() {
    var $slider = $('.js-bannerSlider');
    var slideCount = $slider.find('.swiper-slide').length;

    if (slideCount > 1) {
      bannerSwiper = new Swiper ('.js-bannerSlider', {
        allowTouchMove: true,
        speed: 1500,
        effect: 'fade',
        loop: true,
        autoHeight: true,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        fadeEffect: {
          crossFade: true
        },
      });
    }
  });

  $(function() {
    var $window = $(window);
    var $headerContainer = $('.l-headerContainer');
    var $fixedMenu = $('.l-fixedMenu');
    var $topSection = $('.p-topSection');
    var headerVisibleClass = 'is-menuVisible';
    var headerShowScrollTop = 50;
    var headerShowDelay = 30000;
    var headerInitialVisible = $headerContainer.data('menuInitialVisible') === true;
    var headerShowTimer;

    var showHeader = function() {
      if ($headerContainer.hasClass(headerVisibleClass)) {
        return;
      }

      $headerContainer.addClass(headerVisibleClass);
      $topSection.addClass(headerVisibleClass);
      $fixedMenu.addClass(headerVisibleClass);

      $window.off('scroll load pageshow', showHeaderByScroll);

      if (headerShowTimer) {
        clearTimeout(headerShowTimer);
        headerShowTimer = null;
      }
    };

    var showHeaderByScroll = function() {
      if ($window.scrollTop() >= headerShowScrollTop) {
        showHeader();
      }
    };

    if ($headerContainer.length > 0) {
      if (headerInitialVisible) {
        return;
      }

      headerShowTimer = setTimeout(showHeader, headerShowDelay);
      $window.on('scroll load pageshow', showHeaderByScroll);
      showHeaderByScroll();
    }
  });

  if (slideCount > 1) {
    $(window).on('load resize', function(){
      bannerSwiper.autoplay.paused = false;
      bannerSwiper.autoplay.start();
    });
  }
})();
